import castArray from 'lodash/castArray';
import isEmpty from 'lodash/isEmpty';

export const immutableReverse = (arr) => [...arr].reverse();

export const hasBounds = (query) => ['neLat', 'neLng', 'swLat', 'swLng'].every((k) => !!query[k]);

export const DEFAULT_ZOOM = 14;

export const positionMapToCenter = (gMap, center) => {
  if (!isEmpty(center)) {
    gMap.setCenter(center);
    gMap.setZoom(DEFAULT_ZOOM);
  }
};

export const positionMapToResults = (gMap, gMaps, results) => {
  if (results.length === 0) {
    return;
  }
  const resultsLocations = results.map((result) => ({
    lat: result.latitude,
    lng: result.longitude,
  }));
  const boundsFromResults = createBoundFromPoints(gMaps, resultsLocations);
  fitBounds(gMap, boundsFromResults);
};

export const fitBounds = (gMap, bounds, padding = 0) => gMap.fitBounds(bounds, padding);

export const panToBounds = (gMap, bounds, padding = 0) => gMap.panToBounds(bounds, padding);

export const getBounds = (gMap) => {
  const bounds = gMap.getBounds();
  return bounds ? bounds.toJSON() : {};
};

export const createBoundFromPoints = (gMaps, points) => {
  const bounds = new gMaps.LatLngBounds();
  castArray(points).forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
  return bounds.toJSON();
};

export const getCenter = (center) => (isEmpty(center) ? {} : { lat: center.latitude, lng: center.longitude });
